/**
* Asuntohaun extendatun osan hakuehtorivi. TODO
* 
*/
app.directive('apartmentSearchConstraint', ["$rootScope", "ApartmentSearchModel", function($rootScope, ApartmentSearchModel) {
	
	return {

		restrict: 'EA',
		templateUrl: 'apartment-search-constraint.html',
		scope: {
			constraint: '='
		},
		link: function(scope, element, attrs) {

		},

		controller: ["$scope", function($scope) {
			$scope.SearchModel = ApartmentSearchModel;

			$scope.SingleSelectClick = function(data, index) {
				data.selected = index;
			};
		}]
	};

}]);
	
